import { httpRequest } from "../../http";
import { ChoiceEnumSerializer } from "@models/serializers/choiceEnumSerializer";
import { ChoiceEnum } from "@models/choiceEnum";

export class CommandGetTeamRoles {
  async run(orgType?: "CLIENT" | "PROVIDER") {
    let url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/team-members/roles/`;
    if (orgType) {
      url = url + `?org_type=${orgType}`
    }
    try {
      const response = await httpRequest<any>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): ChoiceEnum[] {
    const serializer = new ChoiceEnumSerializer();
    return serializer.deserializeList(data);
  }
}
